
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ProductFormInventoryProps {
  currentStock: number;
  setCurrentStock: (stock: number) => void;
  usageRate: number;
  setUsageRate: (rate: number) => void;
  minStockAlert: number;
  setMinStockAlert: (alert: number) => void;
  packageSize: number;
  setPackageSize: (size: number) => void;
}

const ProductFormInventory = ({
  currentStock,
  setCurrentStock,
  usageRate,
  setUsageRate,
  minStockAlert,
  setMinStockAlert,
  packageSize,
  setPackageSize,
}: ProductFormInventoryProps) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="current-stock">Current Stock</Label>
          <Input
            id="current-stock"
            type="number"
            min="0"
            value={currentStock}
            onChange={(e) => setCurrentStock(Number(e.target.value))}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="usage-rate">Daily Usage</Label>
          <Input
            id="usage-rate"
            type="number"
            min="0.1"
            step="0.1"
            value={usageRate}
            onChange={(e) => setUsageRate(Number(e.target.value))}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="package-size">Package Size (units per package)</Label>
        <Input
          id="package-size"
          type="number"
          min="0"
          value={packageSize}
          onChange={(e) => setPackageSize(Number(e.target.value))}
          placeholder="Leave 0 if not applicable"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400">
          Number of units in each package from supplier (for ordering purposes)
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="min-stock-alert">Low Stock Alert (days)</Label>
        <Input
          id="min-stock-alert"
          type="number"
          min="1"
          value={minStockAlert}
          onChange={(e) => setMinStockAlert(Number(e.target.value))}
        />
        <p className="text-xs text-gray-500 dark:text-gray-400">
          Alert when you have less than this many days of supply remaining
        </p>
      </div>
    </div>
  );
};

export default ProductFormInventory;
